import { useContext, lazy, Suspense } from "react";
import { Context } from "../ContextProvider";
import { Routes, Route, useNavigate } from 'react-router-dom';
import { SpinnerComponent } from "../../Component/Common";
import { ProtectedLayout } from '../ProtectedLayout';
import { useIdleTimer } from 'react-idle-timer';

const Login = lazy(() => import('../Login').then(m => ({ default: m.Login })));
const ForgotPassword = lazy(() => import('../ForgotPassword').then(m => ({ default: m.ForgotPassword })));
const HomePage = lazy(() => import('../Homepage').then(m => ({ default: m.HomePage })));
const VisitSummary = lazy(() => import('../VisitSummary').then(m => ({ default: m.VisitSummary })));
const Admin = lazy(() => import('../Admin').then(m => ({ default: m.Admin })));
const Dashboard = lazy(() => import('../Admin/DataDashboard').then(m => ({ default: m.Dashboard })));
const User = lazy(() => import('../Admin/User').then(m => ({ default: m.User })));
const ClinicalProtocol = lazy(() => import('../Admin/ClinicalProtocol').then(m => ({ default: m.ClinicalProtocol })));
const LicenceKey = lazy(() => import('../Admin/ClinicalProtocol/Protocol').then(m => ({ default: m.LicenceKey })));
const VisualAcuity = lazy(() => import('../Admin/ClinicalProtocol/VisualAcuity').then(m => ({ default: m.VisualAcuity })));
const Concept = lazy(() => import('../Admin/ClinicalProtocol/Concept').then(m => ({ default: m.Concept })));
const HospitalCode = lazy(() => import('../Admin/HospitalCode').then(m => ({ default: m.HospitalCode })));
const SNCEhr = lazy(() => import('../Admin/SNCEhr').then(m => ({ default: m.SNCEhr })));
const Report = lazy(() => import('../Admin/Report').then(m => ({ default: m.Report })));

function App() {
  const { updateState } = useContext(Context);
  const navigate = useNavigate();

  const handleOnIdle = () => {
    updateState('user', null)
    navigate('/')
  }

  useIdleTimer({
    timeout: 1000 * 60 * 10,
    onIdle: handleOnIdle,
    debounce: 500
  })

  return (
    <Suspense fallback={<SpinnerComponent />}>
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/forgot/:id/:expiry" element={<ForgotPassword />} />
      <Route element={<ProtectedLayout />}>
        <Route path="/home" element={<HomePage />} />
        <Route path="/visitsummary/:id" element={<VisitSummary />} />
        <Route path="/admin" element={<Admin />} >
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="user" element={<User />} />
          <Route path="clinical" element={<ClinicalProtocol />} >
            <Route path="protocol" element={<LicenceKey />} />
            <Route path="acuity" element={<VisualAcuity />} />
            <Route path="concept" element={<Concept />} />
          </Route>
          <Route path="hospitalcode" element={<HospitalCode />} />
          <Route path="sncehr" element={<SNCEhr />} />
          <Route path="report" element={<Report />} />
        </Route>
      </Route>
    </Routes>
    </Suspense>
  );

}

export default App;
